import lang from './../../../../../../languages/en';
import { regexAlphabetNotSpaces, regexIsRomanji } from './../../../../../../services/ruleValidate';

export const fieldRequire = ['sku', 'item_code', 'en_title']

export const fillKeyTooltip = (name, state) => {
    return name + state.inputs.key
}

export const checkFieldEmpty = (value, name, state, type) => {
    if (value) return state;
    if (fieldRequire.indexOf(name) !== -1) {
        if (type === 'blur') {
            if (name !== 'country_of_origin') {
                state.inputs.classes[name] = 'error'
            } else {
                state.inputs.classes[name] = ''
            }
        } else {
            state.tooltip = fillKeyTooltip(name, state)
            state.message = lang.field_required
        }
    } else {
        state.inputs.classes[name] = ''
    }
    return state;
}

export const checkFieldCountryOfOrigin = (value, name, state, type) => {
    if (!regexAlphabetNotSpaces(value)) {
        if (type === 'blur') {
            state.inputs.classes.country_of_origin = 'error'
        } else {
            state.message = lang.only_alphabet
            state.tooltip = fillKeyTooltip(name, state)
        }
    } else {
        state.inputs.classes[name] = ''
    }
    return state
}

export const checkFieldItemCodeAndEnTitle = (value, name, state, type) => {
    if (!regexIsRomanji(value)) {
        if (type === 'blur') {
            state.inputs.classes[name] = 'error'
        } else {
            state.message = lang.prohibited_characters
            state.tooltip = fillKeyTooltip(name, state)
        }
    } else {
        state.inputs.classes[name] = ''
    }
    return state;
}

export const checkFieldSku = (value, name, state, type) => {
    if (!regexIsRomanji(value)) {
        if (type === 'blur') {
            state.inputs.classes[name] = 'error'
        } else {
            state.message = lang.prohibited_characters
            state.tooltip = fillKeyTooltip(name, state)
        }
    } else {
        state.inputs.classes[name] = ''
    }
    
    return state;
}

export const validate = (value, name, state, type) => {
    let result = state;
    if (!value) return;
    switch (name) {
        case 'sku':
            result = checkFieldSku(value, name, state, type)
            break;
        case 'item_code':
            result = checkFieldItemCodeAndEnTitle(value, name, state, type)
            break;
        case 'en_title':
            result = checkFieldItemCodeAndEnTitle(value, name, state, type)
            break;
        case 'country_of_origin':
            result = checkFieldCountryOfOrigin(value, name, state, type)
            break;
        default:
            break;
    }
    return result;
}

export const rowItemName = (key) => {
    if (typeof key === 'undefined' || !key) {
        key = Date.now();
    }
    return {
        id: key,
        key: key,
        checked: false,
        sku: undefined,
        item_code: undefined,
        en_title: undefined,
        jp_title: undefined,
        country_of_origin: undefined,
        hasEdit: false,
        addRow: true,
        classes: {
            sku: '',
            item_code: '',
            en_title: '',
            jp_title: '',
            country_of_origin: ''
        },
    }
}

/**
 * Focus input first and scroll
 */
export const focusTblInputNewFirst = () => {
    let inputs = document.querySelectorAll('.table-merchant-setting tbody tr td.sku input, '
        + '.table-merchant-setting tbody tr td.item-code input, '
        + '.table-merchant-setting tbody tr td.en-title input');
    let length = inputs.length;
    if (!length) {
        return true;
    }
    let inputNull = null;
    for (let i = 0; i < length; i++) {
        if (inputs[i].value.length === 0) {
            inputNull = inputs[i];
            break
        }
    }
    if (!inputNull) {
        return false;
    }
    window.scrollTo(0, inputNull.offsetTop - 20);
    inputNull.focus();
}


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/row-prohibited-items/helper.js